import { clearCookies } from "../cookies";
import { errorNotification } from "../errorNotification";

export const handleTrpcError = (error: any) => {
    // Extract clean TRPC message always
    const trpcMessage =
        error?.error?.json?.message ||
        error?.data?.json?.message ||
        error?.shape?.message ||
        error?.message ||
        "Something went wrong";

    const code = error?.data?.code;

    switch (code) {
        case "UNAUTHORIZED":
        case "FORBIDDEN":
            clearCookies();
            localStorage.clear();
            window.location.href = "/login";
            break;

        case "ERR_LOGIN_INVALID_USER":
            window.location.href = "/unauthorized";
            break;

        case "ERR_LOGIN_INVALID_PASSWORD":
            break;

        case "BAD_REQUEST":
            errorNotification({
                title: "Invalid Request",
                message: trpcMessage,
            });
            break;

        default:
            errorNotification({
                title: code || "Error",
                message: trpcMessage,
            });
    }
};
